import { Box, Stack, Typography } from '@mui/material';

import { FOOTER_HEIGHT } from '@/components/navigation/Footer';
import { COLORS } from '@/styles/tokens/colors';

interface LayoutWithSidePanelProps {
  heading: React.ReactNode;
  subheading: React.ReactNode;
  MainContent: React.ReactElement;
  SidebarContent: React.ReactElement;
  Footer: React.ReactElement;
}

export function LayoutWithSidePanel({
  heading,
  subheading,
  MainContent,
  SidebarContent,
  Footer,
}: LayoutWithSidePanelProps) {
  return (
    <Box>
      <Stack height={`calc(100vh - ${FOOTER_HEIGHT}px)`} overflow="auto">
        <Stack direction="row" width="100%" height="100%">
          <Box p={2} width="65%" overflow="auto">
            <Stack
              sx={{
                pb: 3,
                mb: 3,
                borderBottom: `solid ${COLORS.ORANGE[500]} 1px`,
              }}
            >
              <Typography variant="title-xl">{heading}</Typography>
              <Typography variant="body-xs">{subheading}</Typography>
            </Stack>
            <Box>{MainContent}</Box>
          </Box>
          <Box
            width="35%"
            sx={{
              borderLeft: `1px solid ${COLORS.GRAY[200]}`,
            }}
          >
            {SidebarContent}
          </Box>
        </Stack>
      </Stack>
      <Box>{Footer}</Box>
    </Box>
  );
}
